import { principles, testimonials, brandName, brandSlogan } from "@/mocks/gossip";

export default function About() {
  return (
    <section id="about" className="scroll-mt-28 border-t border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="text-xs font-bold uppercase tracking-widest text-accent-700">About Us</span>
            <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              我们为什么做 {brandName}
            </h2>
            <p className="mt-5 text-sm leading-8 text-foreground-700 md:text-base">
              信息越密、反转越快，普通人越难看清一个「大瓜」的来龙去脉。{brandName} 想做的，
              是那座<b className="font-semibold text-foreground-900">不抢速度、只求扎实</b>的瓜田编辑部——
              把散落在各平台的线索拼回一条可追溯的时间线，把情绪留给读者，把事实尽量讲清楚。
            </p>
            <p className="mt-4 text-sm leading-8 text-foreground-700 md:text-base">
              我们相信：围观不该变成伤害，好奇不该沦为站队。还原真相的尽头，是让每个人都能
              <span className="font-semibold text-primary-700">{brandSlogan}</span>，带着完整证据从容下判断。
            </p>

            <h4 className="mt-7 text-sm font-bold text-foreground-950">我们的内容原则</h4>
            <ul className="mt-3 space-y-2.5">
              {principles.map((p) => (
                <li key={p} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
                    <i className="ri-check-line h-3 w-3"></i>
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative h-44">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20diverse%20group%20of%20young%20people%20sitting%20around%20a%20coffee%20table%20talking%20over%20scattered%20newspapers%20and%20magnifying%20glasses%2C%20cream%20and%20coral%20palette%2C%20modern%20media%20teamwork%20scene%2C%20soft%20and%20friendly%2C%20clean%20minimal&width=900&height=460&seq=chigua-about&orientation=landscape"
                  alt="吃瓜糖心编辑部在梳理线索与信源的工作场景"
                  title="吃瓜糖心编辑部 · 深扒内幕细节与真相还原"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="p-5">
                <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                  <i className="ri-heart-3-fill h-4 w-4 text-primary-500"></i>
                  读者怎么说
                </h3>
                <ul className="mt-3 space-y-3">
                  {testimonials.map((t) => (
                    <li key={t.name} className="rounded-xl bg-background-100/80 p-3.5">
                      <p className="text-sm leading-6 text-foreground-700">“{t.text}”</p>
                      <p className="mt-2 text-xs font-semibold text-foreground-950">
                        {t.name}
                        <span className="ml-2 font-normal text-foreground-500">{t.role}</span>
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}